import baseUrl from "../config/baseUrl";

const getPendingChasingDocuments = async ({ token, contact_id }) => {
  try {
    const response = await fetch(`${baseUrl}/api/get-client-pending-chasing-documents?contact_id=${contact_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getPendingChasingDocuments;
